function SimulatorController(CommonService, stateService, simulatorService, $state, $scope) {
  const ctrl = this;
  const tryCatch = CommonService.tryCatch;

  ctrl.$onInit = async () => {
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    if (!ctrl.workspaceId) $state.go('pis.workspaces');
    ctrl.dataLoading = true;
    const trainNumbersData = await fetchTrainNumbers(ctrl.workspaceId);
    const runsAndRoutesData = await fetchRunsAndRoutes(ctrl.workspaceId);
    const segments = await fetchSegments();
    const stationsData = await fetchStations(ctrl.workspaceId);
    
    ctrl.stations = stationsData.stations.sort(byName);
    ctrl.simulatorScripts = segments.filter(s => s.simulator_script);
    ctrl.trainNumbers = trainNumbersData.train_numbers.sort(byNumber);
    ctrl.runs = runsAndRoutesData.runs;
    ctrl.dataLoading = false;
    ctrl.editMode = false;
    // These are default values for simulation options.
    ctrl.simulationOptions = {
      run: null,
      reporting_interval: 1.0,
      time_between_station: "TIME_BETWEEN_STATIONS",
      acc_variable: "ACC_VARIABLE",
      max_speed_variable: "MAX_SPEED",
      stop_time_variable: "STOP_TIME",
      script_segment: null,
      max_speed: 50.0,
      acc_constant: 1.0,
      iteration_time: 0.01,
      stop_time: 12.0,
      train_num: null,
      workspaces: [ctrl.workspaceId],
      name: "",
      save: false,
      add_end_of_script: "",
      engine_messages: true,
      train_information: true,
      index: 0
    };
  };

  function byName(a, b) {
    // Sorter function to order objects alphabetically by name
    // Use toUpperCase() to ignore character casing
    const stationA = a.name.toUpperCase();
    const stationB = b.name.toUpperCase();
  
    let comparison = 0;
    if (stationA > stationB) {
      comparison = 1;
    } else if (stationA < stationB) {
      comparison = -1;
    }
    return comparison;
  }

  function byNumber(a, b) {
    // Sorter function to order objects by a numberical key
    return a.number - b.number;
  }

  ctrl.onBeginSimulation = async (event) => {
    ctrl.editMode = true;
    ctrl.simulationParams = event.options;
    ctrl.simulationOptions.index = event.options.index;
    ctrl.simulationOptions.train_num = ctrl.simulationParams.trainNumber.number;
    ctrl.simulationOptions.run = ctrl.simulationParams.selectedRunId;
    ctrl.simulationOptions.script_segment = ctrl.simulationParams.simulatorScript.id;
    const dateConverted = new Date(ctrl.simulationParams.date);
    const dateString = dateConverted.toISOString().substring(0, dateConverted.toISOString().length - 1);
    ctrl.simulationOptions.add_end_of_script = `BEGIN\nDATE ${dateString}\nALWAYS\n&TRAIN_NUMBER ${ctrl.simulationOptions.train_num}`;
    ctrl.dataLoading = true;

    ctrl.simulationData = await initiateSimulation(ctrl.workspaceId, ctrl.simulationOptions);
    console.log("Simulation data:");
    console.log(ctrl.simulationData);
    if (ctrl.simulationData.errors_outside_of_simulation && ctrl.simulationData.errors_outside_of_simulation[0]) {
      alert("PIS Simulator Error\n" + ctrl.simulationData.errors_outside_of_simulation[0] );
    }
    if (ctrl.simulationData.info_outside_of_simulation && ctrl.simulationData.info_outside_of_simulation[0]) {
      alert("PIS Simulator Info\n" + ctrl.simulationData.info_outside_of_simulation[0] );
    }

    ctrl.dataLoading = false;
    $state.go('pis.workspaces.simulator.runner');
  };

  ctrl.backToSetup = () => {
    $state.go('pis.workspaces.simulator.form');
    ctrl.editMode = false;
  };

  // Fetch object of train numbers, wrapped in tryCatch, returns data if no error.
  // fetchTrainNumbers :: (Object) -> (Object)
  const fetchTrainNumbers = params =>
    tryCatch(() => stateService.getTrainNumbers(params))
      .fold(e => {
        console.error(`Trainnumber fetch error: ${e}`);
        return e;
      },
        data => data);

  // Fetch object of train numbers, wrapped in tryCatch, returns data if no error.
  // fetchTrainNumbers :: (Object) -> (Object)
  const fetchRunsAndRoutes = params =>
    tryCatch(() => stateService.getRunsAndRoutes(params))
      .fold(e => {
        console.error(`Trainnumber fetch error: ${e}`);
        return e;
      },
        data => data);

  // Fetch list of segments, wrapped in tryCatch, returns data if no error.
  // fetchSimulatorScripts :: (Object) -> [Object]
  const fetchSegments = () =>
    tryCatch(() => stateService.getSegments())
      .fold(e => {
        console.error(`Script fetch error: ${e}`);
        return e;
      },
        data => data);


  const fetchStations = params =>
      tryCatch(() => stateService.getStations(params))
      .fold(e => {
        console.error(`Stations fetch error: ${e}`);
        return e;
      },
        data => data);

  // Fetch object of train numbers, wrapped in tryCatch, returns data if no error.
  // initiateSimulation :: (Object) -> (Object)
  const initiateSimulation = (id, params) =>
    tryCatch(() => simulatorService.initiateSimulation(id, params))
      .fold(e => {
        console.error(`Simulation data fetch error: ${e}`);
        return e;
      },
        data => data);
}

angular
  .module('pis-tool.module')
  .controller('SimulatorController', SimulatorController);
